import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { PhxTagUpsellType } from './phx-tag-upsell.types';

@Component({
  selector: 'phx-tag-upsell',
  styleUrls: ['./phx-tag-upsell.component.scss'],
  templateUrl: './phx-tag-upsell.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-tag-upsell',
    '[class.phx-tag-upsell-accent]': `phxTagType === 'accent'`,
    '[class.phx-tag-upsell-caution]': `phxTagType === 'caution'`,
    '[class.phx-tag-upsell-warning]': `phxTagType === 'warning'`,
    '[class.phx-has-prefix]': '!!phxPrefixIcon',
    '(click)': 'handleClick($event)',
  },
})
export class PhxTagUpsellComponent {
  @Input() public phxTagType: PhxTagUpsellType = 'accent';
  @Input() public phxPrefixIcon: string | null = null;
  @Output() public phxOnClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  public handleClick(event: MouseEvent): void {
    this.phxOnClick.emit(event);
  }
}
